import React from 'react';
import styles from './loader.module.scss';
import { iconLoader } from '../../../assets/images';

/**
 * Non-modal loader overlay.
 * Do NOT use MUI Backdrop/Modal here — Modal roots stay position:fixed and
 * keep capturing clicks even when the inner layer has pointer-events:none,
 * which freezes the whole dashboard (arrow cursor, no hand pointer).
 */
function Loader({ showLoader }: { showLoader: boolean }): JSX.Element | null {
  if (!showLoader) {
    return null;
  }

  return (
    <div
      className={styles.loaderContainer}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <img src={iconLoader} height={60} alt="Loading" />
    </div>
  );
}

export default Loader;
